// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingEpostValidationErrorsReportModal-moduletable__inGrU TableComponent-moduleTable__mhqNq";
export { _1 as "table" }
